import router from '@/router'
import axios from 'axios'
import { ElMessage, ElMessageBox } from 'element-plus'
import { useAuthStore } from '@/stores/auth'
import { useShipmentStore } from '@/stores/shipment'

// API URLs
export const API_URLS = {
  AUTH: {
    LOGIN: '/login/toLogin',
    GET_USER: '/user/userInfo', //获取用户信息
    REGISTER: '/user/register',
    REFRESH_TOKEN: '/v1/account/refresh_token',
    LOGOUT: '/login/quit',
    SEND_VERIFICATION_CODE: '/email/send',
  },
  PROFILE: {
    GET: '/user/userInfo',
    UPDATE: '/user/update',
    BALANCE_CHANGE_LOG: '/bill/search',
    BALANCE_CHANGE_LOG_MY: '/user/getUserBill',
    EXPORT_BALANCE_CHANGE_LOG: '/bill/export',
  },
  USER: {
    GET: '/user/search', //查询用户列表
    FINDALL: '/user/findAll', //查询可以授权的用户列表
  },
  MENU: {
    GET: '/menu/search',
    UPDATE: '/menu/update',
    DELETE: '/menu/delete',
    ADD: '/menu/create',
  },
  ROLE: {
    GET: '/role/search',
    UPDATE: '/role/update',
    DELETE: '/role/delete',
    ADD: '/role/create',
    BINDMENU: '/role/bindMenus',
    GETBINDMENU: '/role/menu/list',
    BINDUSER: '/role/bindUsers',
    GETBINDUSER: '/role/user/list',
    REMOVEUSER: '/role/removeUser',
  },
  ADDRESS: {
    BASE: '/address/search',
    ADD: '/address/create',
    UPDATE: '/address/update',
    DELETE: '/address/delete',
  },
  CUSTOMER: {
    CUSTOMER_LIST: '/customer/search',
    CUSTOMER_COMMISSION: 'commission/update',
    CUSTOMER_BALANCE: '/bill/create',
    ADMIN_SETTING: '/user/setting',
    UPDATE_PASSWORD: '/customer/updatePwd',
    INVITE_CODE: '/customers/invite-code',
    REFRESH_INVITE_CODE: '/customers/invite-code/refresh',
    CUSTOMER_ORDERS: '/customer/findOrderList',
    DELETE_USER: '/customer/delete',
    DETAIL_USER: '/user/get',
  },
  ORDER: {
    LIST: '/order/search',
    DETAIL: '/order/get',
    DETAILBYORDERNO: '/bill/getOrder',
    CANCEL_ORDER: '/order/cancel',
    // ADJUST_BALANCE: '/v1/shipment/adjust_balance',
    UPDATE_ORDER_EXTRA_DEBIT: '/order/backCharge',
    EXPORT: '/order/export',
    AUDIT: '/order/audit',
    BACK_ORDER: '/order/backOrder',
    UPDATE_BOL: '/order/updateBol', //编辑提货单URL
    DETAil_XQ: '/order/getOrderRequest', //
    UPDATE_XQ: '/order/updateStatus', //
  },
  SHIPMENT: {
    GET_QUOTES: '/quote/rates',
    SAVE_QUOTES: '/quote/create',
    BOOK_SHIPMENT: '/order/create',
    CANCEL: '/api/cancelShipment',
    ZIP: '/address/getZipCode', //根据编码查询对应城市
    TRANSLATE: '/v1/shipment/translate',
    GET_QUOTE_HISTORY: '/quote/search',
    GET_SHIPMENT_HISTORY_GOODS: '/quote/findGoods', //查询运价货物
    GET_SHIPMENT_HISTORY_PRICE: '/quote/findPrice', //查询运价报价
    GET_SHIPMENT_HISTORY_DETAIL: '/quote/get',
  },
}
const PATH_URL = import.meta.env.VITE_API_BASE_URL
const api = axios.create({
  baseURL: PATH_URL,
  // baseURL: 'https://api-dev.guiyangvoyage.cn/',
  timeout: 0,
  headers: {
    'Content-Type': 'application/json',
  },
})

// 不需要token的白名单路径
// const whiteList = [API_URLS.AUTH.LOGIN, API_URLS.AUTH.REGISTER]

// 添加请求拦截器
api.interceptors.request.use(
  config => {
    // 检查请求路径是否在白名单中
    // const isWhitelisted = whiteList.some(path => config.url?.includes(path))
    // if (!isWhitelisted) {
    //   const token = localStorage.getItem('auth_token')
    //   if (token) {
    //     config.headers.token = token
    //   }
    // }
    return config
  },
  error => {
    return Promise.reject(error)
  }
)
const currentRoute = useRoute()

// 添加响应拦截器
api.interceptors.response.use(
  (response: any) => {
    const res = response.data
    // 判断如果是返回流，则直接返回
    if (Object.prototype.toString.apply(response.data) === '[object Blob]') {
      if (
        response.config.responseType &&
        response.config.responseType === 'blob'
      ) {
        if (res.type === 'application/json') {
          const reader: any = new FileReader()
          reader.readAsText(res, 'utf-8')
          reader.addEventListener('loadend', function () {
            const jsonRes = JSON.parse(reader.result)
            return Promise.reject(jsonRes.msg || jsonRes.error || 'error')
          })
        } else {
          return response
        }
      } else {
        return response
      }
    }
    // 如果返回的code是1，成功处理，如果是999，跳转登录
    else if (response.data.code === 1 || response.data.code === 888) {
      return response
    } else if (response.data.code === 999) {
      // 提示登录过期的确认框
      ElMessageBox.confirm('登录已过期，请重新登录！', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        showClose: false,
        closeOnClickModal: false,
        closeOnPressEscape: false,
      })
        .then(
          () => {
            const authStore = useAuthStore()
            // token过期，跳转到登录页面
            authStore.clearAuth()

            // 2. 获取当前路由的完整路径，用于登录后跳回
            // 注意：如果在拦截器中，建议使用 router.currentRoute.value
            const redirectPath = router.currentRoute.value.fullPath
            router
              .replace({
                path: '/login',
                query: { redirect: redirectPath },
              })
              .catch(err => {
                // 捕获路由跳转可能出现的错误（例如重复跳转）
                console.error('Navigation failed:', err)
              })
            // 刷新页面
            // window.location.reload()
            return Promise.reject(response.data.message)
          },
          () => {
            // 取消操作
          }
        )
        .catch(() => {})
      return Promise.reject(response.data.message)
    } else {
      ElMessage({
        message: response.data.message,
        type: 'error',
        duration: 3000,
        showClose: true,
      })
      return Promise.reject(response.data.message)
    }
  },
  error => {
    if (error.response) {
      switch (error.response.status) {
        case 401:
          // token过期，跳转到登录页面
          localStorage.removeItem('auth_token')
          localStorage.removeItem('refresh_token')
          localStorage.removeItem('user_info')
          // window.location.href = '/login'
          router.push({
            path: '/login',
            replace: true,
            query: { redirect: currentRoute.fullPath },
          })
          break
        case 500:
          // 服务器错误
          break
        default:
          break
      }
    }
    return Promise.reject(error)
  }
)
export default api
